/* KALUP - welcome popup with the 5% code (KALUPWELCOME5).
   Gift-coupon design: brand-blue top with a giant yellow "5%", ticket cut,
   white bottom with the code and a big yellow button. Shows EVERY time the
   site is opened: arriving from outside (Google, Instagram, a link, typing the
   address) or refreshing the page - 1s after the page loads. Not shown while
   moving between pages inside the site, and not on cart / account pages. "فعّل خصمي" applies the code through Shopify's /discount
   link, so it is added at checkout automatically. Edit CONFIG to change it. */
(function () {
  var CONFIG = {
    code: 'KALUPWELCOME5',
    percent: 5,
    delayMs: 1000
  };

  if (window.Shopify && window.Shopify.designMode) return;
  if (/^\/(cart|checkouts?|account|challenge|password)/.test(location.pathname)) return;

  /* Opening the site = coming from another site / typing the address / refreshing.
     Clicking from one page of the site to another does not show it again. */
  var navType = '';
  try {
    var navEntry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    navType = navEntry ? navEntry.type : (performance.navigation && performance.navigation.type === 1 ? 'reload' : '');
  } catch (e) {}
  var fromHost = '';
  try { fromHost = document.referrer ? new URL(document.referrer).host : ''; } catch (e) {}
  if (fromHost === location.host && navType !== 'reload') return;

  var css =
    '.kwp{position:fixed;inset:0;z-index:2147482000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.75);opacity:0;transition:opacity .25s ease}' +
    '.kwp.is-open{opacity:1}' +
    '.kwp__card{position:relative;width:100%;max-width:390px;overflow:hidden;border-radius:24px;font-family:Cairo,"Segoe UI",Arial,sans-serif;text-align:center;box-shadow:0 0 0 4px rgba(255,214,10,.9),0 30px 80px -20px rgba(0,0,0,.9);transform:translateY(30px) scale(.9);transition:transform .45s cubic-bezier(.2,1.4,.35,1)}' +
    '.kwp.is-open .kwp__card{transform:none}' +
    /* top: brand blue gift */
    '.kwp__top{position:relative;padding:34px 22px 30px;background-color:#1a6bcc;background-image:repeating-linear-gradient(135deg,rgba(255,255,255,.07) 0 14px,transparent 14px 28px);color:#fff}' +
    '.kwp__top::after{content:"";position:absolute;top:0;left:-60%;width:40%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.28),transparent);transform:skewX(-20deg);animation:kwp-shine 2.8s ease-in-out .6s infinite}' +
    '.kwp__ribbon{position:absolute;top:16px;right:-38px;display:flex;align-items:center;gap:5px;padding:6px 44px;background:#ffd60a;color:#0b0b0b;font-size:12.5px;font-weight:900;transform:rotate(35deg);box-shadow:0 4px 10px rgba(0,0,0,.25)}' +
    '.kwp__ribbon svg{width:13px;height:13px}' +
    '.kwp__close{position:absolute;top:12px;left:12px;z-index:2;display:flex;align-items:center;justify-content:center;width:36px;height:36px;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.95);color:#1a6bcc;cursor:pointer}' +
    '.kwp__close:hover{background:#ffd60a;color:#0b0b0b}' +
    '.kwp__close svg{width:14px;height:14px}' +
    '.kwp__env{display:inline-flex;align-items:center;justify-content:center;width:52px;height:52px;margin:0 0 8px;border-radius:50%;background:#fff;color:#1a6bcc;box-shadow:0 6px 16px rgba(0,0,0,.2)}' +
    '.kwp__env svg{width:26px;height:26px}' +
    '.kwp__eyebrow{margin:0 0 2px;color:#ffd60a;font-size:15px;font-weight:900}' +
    '.kwp__title{margin:0 0 6px;color:#fff;font-size:24px;font-weight:900;line-height:1.35}' +
    '.kwp__big{display:flex;align-items:center;justify-content:center;gap:10px;line-height:1}' +
    '.kwp__pct{color:#ffd60a;font-family:"Barlow Condensed","Arial Narrow",sans-serif;font-size:104px;font-weight:800;letter-spacing:-.02em;text-shadow:0 6px 0 rgba(0,0,0,.18);animation:kwp-pulse 1.8s ease-in-out 1s infinite}' +
    '.kwp__off{display:flex;flex-direction:column;align-items:flex-start;color:#fff;font-size:26px;font-weight:900;line-height:1.1}' +
    '.kwp__off small{font-size:14px;font-weight:700;opacity:.9}' +
    /* ticket cut */
    '.kwp__cut{position:relative;height:0;border-top:2.5px dashed rgba(26,107,204,.45)}' +
    '.kwp__cut::before,.kwp__cut::after{content:"";position:absolute;top:-14px;width:28px;height:28px;border-radius:50%;background:#0b0b0b}' +
    '.kwp__cut::before{left:-14px}' +
    '.kwp__cut::after{right:-14px}' +
    /* bottom: white */
    '.kwp__bottom{padding:20px 22px 20px;background:#fff;color:#0d0d0d}' +
    '.kwp__sub{margin:0 0 14px;color:#374151;font-size:14.5px;font-weight:600;line-height:1.7}' +
    '.kwp__code{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:0 0 12px;padding:7px 7px 7px 14px;border:2px dashed #1a6bcc;border-radius:12px;background:#eef5fd;direction:ltr}' +
    '.kwp__code span{color:#0d0d0d;font-family:"Barlow Condensed","Arial Narrow",sans-serif;font-size:23px;font-weight:800;letter-spacing:.08em}' +
    '.kwp__copy{min-height:36px;padding:0 14px;border:0;border-radius:999px;background:#0d0d0d;color:#fff;font:inherit;font-size:13px;font-weight:800;cursor:pointer;white-space:nowrap}' +
    '.kwp__copy:hover{background:#1a6bcc}' +
    '.kwp__go{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;min-height:56px;border:0;border-radius:999px;background:#ffd60a;color:#0b0b0b;font:inherit;font-size:18px;font-weight:900;cursor:pointer;box-shadow:0 8px 0 #d4ad00;transition:transform .15s ease,box-shadow .15s ease,background-color .2s ease}' +
    '.kwp__go:hover{background:#ffe03d}' +
    '.kwp__go:active{transform:translateY(4px);box-shadow:0 4px 0 #d4ad00}' +
    '.kwp__go[disabled]{opacity:.7;cursor:wait}' +
    '.kwp__go svg{width:20px;height:20px}' +
    '.kwp__note{margin:12px 0 0;color:#6b7280;font-size:12.5px}' +
    '.kwp__done{display:none;margin:0 0 12px;padding:10px 12px;border-radius:12px;background:#e8f6ee;color:#12723c;font-size:14.5px;font-weight:800}' +
    '.kwp.is-applied .kwp__done{display:block}' +
    '.kwp.is-applied .kwp__code{display:none}' +
    '.kwp button:focus-visible{outline:3px solid #0d0d0d;outline-offset:2px}' +
    '@keyframes kwp-shine{0%{left:-60%}55%,100%{left:130%}}' +
    '@keyframes kwp-pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.06)}}' +
    '@media (max-width:380px){.kwp__pct{font-size:88px}.kwp__title{font-size:21px}}' +
    '@media (prefers-reduced-motion:reduce){.kwp,.kwp__card{transition:none}.kwp__top::after,.kwp__pct{animation:none}}';

  var icon = {
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    mail: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v9H5v-9"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>'
  };

  function open() {
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    var lastFocus = document.activeElement;
    var wrap = document.createElement('div');
    wrap.className = 'kwp';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', 'kwp-title');
    wrap.setAttribute('dir', 'rtl');
    wrap.innerHTML =
      '<div class="kwp__card">' +
        '<div class="kwp__top">' +
          '<button type="button" class="kwp__close" aria-label="إغلاق">' + icon.close + '</button>' +
          '<span class="kwp__ribbon">' + icon.clock + 'لفترة محدودة</span>' +
          '<span class="kwp__env">' + icon.mail + '</span>' +
          '<h3 class="kwp__title" id="kwp-title">هدية من KALUP</h3>' +
          '<div class="kwp__big"><span class="kwp__pct" dir="ltr">' + CONFIG.percent + '%</span><span class="kwp__off">خصم<small>على أوردرك</small></span></div>' +
        '</div>' +
        '<div class="kwp__cut" aria-hidden="true"></div>' +
        '<div class="kwp__bottom">' +
          '<p class="kwp__sub">فعّل الخصم دلوقتي وهيتطبق تلقائياً في صفحة الدفع.</p>' +
          '<p class="kwp__done">✓ الخصم اتفعّل! هيتطبق تلقائياً في صفحة الدفع.</p>' +
          '<div class="kwp__code"><span>' + CONFIG.code + '</span><button type="button" class="kwp__copy">انسخ</button></div>' +
          '<button type="button" class="kwp__go">' + icon.gift + '<span>فعّل خصمي دلوقتي</span></button>' +
          '<p class="kwp__note">أو استخدم الكود في صفحة الدفع.</p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(wrap);
    requestAnimationFrame(function () { wrap.classList.add('is-open'); });

    var go = wrap.querySelector('.kwp__go');
    var goLabel = go.querySelector('span');
    var copyBtn = wrap.querySelector('.kwp__copy');
    go.focus();

    function close() {
      document.removeEventListener('keydown', onKey);
      wrap.classList.remove('is-open');
      setTimeout(function () { wrap.remove(); style.remove(); }, 250);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    document.addEventListener('keydown', onKey);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    wrap.querySelector('.kwp__close').addEventListener('click', close);

    copyBtn.addEventListener('click', function () {
      var done = function () { copyBtn.textContent = 'اتنسخ ✓'; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(CONFIG.code).then(done, done);
      } else {
        done();
      }
    });

    go.addEventListener('click', function () {
      if (wrap.classList.contains('is-applied')) return close();
      go.disabled = true;
      fetch('/discount/' + encodeURIComponent(CONFIG.code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
        .catch(function () {})
        .then(function () {
          wrap.classList.add('is-applied');
          go.disabled = false;
          goLabel.textContent = 'ابدأ التسوق';
          wrap.querySelector('.kwp__note').textContent = 'الكود: ' + CONFIG.code;
        });
    });
  }

  function schedule() { setTimeout(open, CONFIG.delayMs); }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule);
})();